function updateUrlWithSlug( newSlug = '' ) {
    var currentUrl = window.location.href;
    var newUrl = currentUrl + newSlug;
    if ( !currentUrl.includes( newSlug)) {
        // Append the slug after the query string
        history.pushState(null, null, newUrl);
    }
}

function removeSlugFromUrl() {
    var currentUrl = window.location.href;
    var newUrl = currentUrl.substring(0, currentUrl.indexOf('?'));
    history.pushState(null, null, newUrl);
}

export const customersPopup = () => {
    var exitButtons = document.querySelectorAll('.popup__customers--exit, .popup__customers--rgba');
    var customersListing = document.querySelectorAll('.open-customers-popup');

    var queryString = window.location.search;
    if ( '' != queryString ) {
        var urlParams = new URLSearchParams( queryString );
        // var customer_post_slug = urlParams.get('slug');
        var customer_post_id = urlParams.get('id');
        if ( customer_post_id ) {
            var id = customer_post_id;
            var endpoint = '/wp-json/ajax-popup-pro/v1/popup';
            var xhr = new XMLHttpRequest();
            xhr.open('POST', endpoint);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            xhr.onload = function() {
                if (xhr.status === 200) {
                    var response = xhr.responseText;
                    var customersDetails = document.querySelector('.popup__customers--details');
                    customersDetails.innerHTML = response;
                    var popupcustomers = document.querySelector('.popup__customers');
                    popupcustomers.classList.add('open');
                }
            };
            xhr.send('id_post=' + encodeURIComponent(id));
        }
    }

    exitButtons.forEach(function(button) {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            var popupcustomers = document.querySelector('.popup__customers');
            popupcustomers.classList.remove('open');
            var postSlug = popupcustomers.querySelector( 'iframe' ).dataset.postSlug;
            removeSlugFromUrl();
            setTimeout(()=>{
                document.querySelector('.popup__customers--details').innerHTML = '';
            }, 400)
        });
    });
    customersListing.forEach(function(button) {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            var id = e.target.closest('.jet-listing-grid__item').getAttribute('data-post-id');
            var endpoint = '/wp-json/ajax-popup-pro/v1/popup';
            var xhr = new XMLHttpRequest();
            xhr.open('POST', endpoint);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            xhr.onload = function() {
                if (xhr.status === 200) {
                    var response = xhr.responseText;
                    var customersDetails = document.querySelector('.popup__customers--details');
                    customersDetails.innerHTML = response;
                    var popupcustomers = document.querySelector('.popup__customers');
                    popupcustomers.classList.add('open');
                    var urlQuery = '?id=' + id;
                    updateUrlWithSlug( urlQuery );
                }
            };
            xhr.send('id_post=' + encodeURIComponent(id));
        });
    });
}